<template>
  <p-usage-audit v-if="$hasPermission('administration.read')" />
  <p-not-found v-else />
</template>

<script>
import UsageAuditExport from '@/components/usage-audit/UsageAuditExport.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  components: {
    'p-usage-audit': UsageAuditExport,
    'p-not-found': NotFound
  }
};
</script>
